import React, { Component } from 'react'

import styles from './styles.module.scss'

class Footer extends Component {
  renderTag = (text, comingSoon = false, noDot = false) => {
    return (
      <span className={`${styles.tag} ${noDot ? styles.noDot : ''}`}>
        {!noDot && (
          <span
            className={`${styles.dot} ${comingSoon ? styles.comingSoon : ''}`}
          >
            •
          </span>
        )}
        {noDot && '# '}
        {text}
      </span>
    )
  }

  render() {
    const projects = [
      {
        clientName: 'Herbarium',
        url: 'https://herbarium.fr/',
        cover:
          'https://a.storyblok.com/f/119451/1080x1620/35ab6aa33e/bdherbarium-janv220044-1.jpeg',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify Plus',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Vercel',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Ulé',
        url: 'https://ulebeauty.com/',
        cover:
          'https://a.storyblok.com/f/119451/900x1125/552dbd6db3/tout-est-clair-2.jpeg',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify Plus',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Vercel',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Nina Ricci',
        url: 'https://ninaricci.com/',
        cover:
          'https://a.storyblok.com/f/119451/1080x1440/22b95af1d7/7e2942e4-a383-4717-ba53-184f6aa1370c_2.jpeg/m/900x1340/filters:focal(0x500:1600x0)',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify Plus',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Vercel',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Jean-Paul Gaultier',
        url: 'https://fashion.jeanpaulgaultier.com/',
        cover:
          'https://img2.storyblok.com/1440x0/filters:quality(70)/f/119451/7133x4588/326d743936/d3fa4e7a-1d2f-4522-8f88-0378bf6bae90_a004c003_210415_r4m2-00196803_300dpi_v2_qc-min.jpg',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify Plus',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'algolia',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Vercel',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'La Bouche Rouge Paris',
        url: 'https://laboucherougeparis.com/',
        cover:
          'https://a.storyblok.com/f/119451/1440x1680/272f19c323/f3c878ab-178c-40d7-b646-82bc870dec1c_red-case-engraved-em-v2.jpeg/m/900x1200',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ERP',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify Plus',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'algolia',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'JEM Paris',
        url: 'https://jem-paris.com',
        cover:
          'https://a.storyblok.com/f/119451/967x1288/066789acc8/e230d55f-822d-4e09-8b55-f9ca4255b9b9_jem_c09_ny02_collier_etreintes_or_jaune_ethique_fairmined_ethical_gold_yellow_gold_necklace-2.jpeg',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'algolia',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Ysé Paris',
        url: 'https://yse-paris.com/',
        cover:
          'https://a.storyblok.com/f/119451/3880x5814/3d096fd180/c6d21e4d-c2d9-420f-b79f-50e63187b13c_yse-pe22-roadtrip-115.jpeg/m/900x1400',
        tags: [
          {
            name: 'Headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ERP',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Shopify Plus',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'algolia',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'ecommerce',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Impala',
        url: 'https://impala.travel/',
        cover:
          'https://a.storyblok.com/f/119451/2800x1866/0c0e1a88bb/6f4aad21-5bf8-4981-93e6-fc5920d40398_hphero.jpeg/m/1200x0',
        tags: [
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'prismic',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'vercel',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'startup',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Strapi',
        url: 'https://strapi.io/',
        cover:
          'https://a.storyblok.com/f/119451/x/9275cbb1b9/features-hero_ca8edd6243.svg',
        tags: [
          {
            name: 'next.js',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'startup',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'strapi',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'algolia',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'cms',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Martell',
        url: 'https://martell.com/en-ww/?avp=0',
        cover:
          'https://img2.storyblok.com/1440x0/filters:quality(70)/f/119451/1032x947/e165c1caa1/martell-sop-quavo-website-article-image1-1500p.jpeg',
        tags: [
          {
            name: 'wordpress',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'showcase',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'react-static',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
      {
        clientName: 'Icicle',
        url: 'https://www.icicle.fr/en/',
        cover:
          'https://img2.storyblok.com/1440x0/filters:quality(70)/f/119451/3072x3686/81d1e11c45/0515-icicle4584.jpeg',
        tags: [
          {
            name: 'react-static',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'twill headless',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'showcase',
            comingSoon: false,
            noDot: true,
          },
          {
            name: 'Live',
            comingSoon: false,
            noDot: false,
          },
        ],
      },
    ]

    return (
      <footer className={styles.Footer}>
        <div className={styles.projects}>
          <h2>Projects</h2>

          <ul>
            {projects.map((p, id) => {
              const statusTag = p.tags.splice(-1)[0]
              return (
                <li key={id} className={!p.url ? styles.soon : ''}>
                  <a target="_blank" rel="noopener noreferrer" href={p.url}>
                    <div className={styles.cover}>
                      {this.renderTag(
                        statusTag.name,
                        statusTag.comingSoon,
                        statusTag.noDot
                      )}
                      <img src={p.cover} alt="Project cover" />
                    </div>
                    <span className={styles.clientName}>{p.clientName}</span>
                    <span className={styles.tags}>
                      {p.tags.map((t) => {
                        return this.renderTag(t.name, t.comingSoon, t.noDot)
                      })}
                    </span>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
        <div className={styles.partners}>
          <h2>Partners</h2>
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://vercel.com/"
              >
                Vercel
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://prismic.io/"
              >
                Prismic
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://storyblok.com/"
              >
                Storyblok
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://shopify.com/"
              >
                Shopify
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://strapi.io/"
              >
                Strapi
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://algolia.com/"
              >
                Algolia
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.mollie.com/"
              >
                Mollie
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.payplug.com/"
              >
                Payplug
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.careers}>
          <h2>Careers</h2>
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto:contact@unlikely.technology"
              >
                • Frontend developer - Typescript / React.js (full time)
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto:contact@unlikely.technology"
              >
                • Backend developer - Typescript / Node.js (full time)
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto:contact@unlikely.technology"
              >
                • Producer (full time)
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.contact}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/unlikely/"
            className={styles.linkedin}
          >
            Linkedin
          </a>
          <a href="mailto:contact@unlikely.technology" className={styles.mail}>
            contact@unlikely.technology
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.google.com/maps/place/Unlikely+Studio/@48.8506784,2.4283268,15z/data=!4m5!3m4!1s0x0:0xa7d5cb6cce8865b5!8m2!3d48.8506784!4d2.4283268"
            className={styles.address}
          >
            12 rue Jean Jacques Rousseau, 93100 Montreuil, France
          </a>
        </div>
      </footer>
    )
  }
}

export default Footer
